// src/components/PageSpinner.jsx
'use client';

import React from 'react';
import clsx from 'clsx';

const BRAND = {
  ink: '#252C3E',
  primary: '#3483FE',
  accent: '#82BEFF',
  border: '#C2C4C9',
};

function SpinnerSVG({ className }) {
  return (
    <svg
      className={clsx('animate-spin', className)}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Loading"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
        opacity="0.15"
      />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

/** Full-screen loading state used during gated/async loads (e.g., entitlements) */
export default function PageSpinner({ label = 'Loading…' }) {
  return (
    <div
      className="fixed inset-0 grid place-items-center bg-white/80 dark:bg-black/50 backdrop-blur-sm z-[60]"
      style={{ color: BRAND.primary }}
    >
      <div className="flex flex-col items-center gap-3">
        <SpinnerSVG className="h-10 w-10" />
        <span
          className="text-sm font-medium text-zinc-700 dark:text-zinc-200"
          style={{ color: BRAND.ink }}
        >
          {label}
        </span>
      </div>
    </div>
  );
}
